import React from "react";
import { Section, ContentBlock, Paragraph, Icon } from "./ui";

const SimpleList = ({
  items = [],
  variant = "transparent",
  spacing = "none",
  maxWidth = "4xl",
  contentSpacing = "comfortable",
  bulletColor = "text-yellow-400",
  bulletStyle = "•",
  useIcon = false,
  iconName = "check",
  iconSize = "sm",
  textVariant = "large",
  showBottomMargin = true,
  className = "",
  color = "var(--color-primary)",
  ...props
}) => {
  return (
    <Section
      variant={variant}
      spacing={spacing}
      className={className}
      {...props}
      style={{ marginTop: "-50px" }}
    >
      <ContentBlock
        maxWidth={maxWidth}
        spacing={contentSpacing}
        className="mx-auto"
      >
        <ul className={`space-y-2 ${showBottomMargin ? "mb-6" : ""}`}>
          {items.map((item, itemIndex) => (
            <li
              key={`list-item-${itemIndex}`}
              className={useIcon ? "flex items-center" : "flex items-start"}
            >
              {useIcon ? (
                <Icon
                  name={iconName}
                  size={iconSize}
                  className={`${bulletColor} mr-3 flex-shrink-0`}
                />
              ) : (
                <span className={`${bulletColor} mr-3 mt-1`}>
                  {bulletStyle}
                </span>
              )}
              <Paragraph
                variant={textVariant}
                color={color}
                noSpacing
                dangerouslySetInnerHTML={{ __html: item }}
              />
            </li>
          ))}
        </ul>
      </ContentBlock>
    </Section>
  );
};

export default SimpleList;
